/* tslint:disable */
/* eslint-disable */
export enum QuestionType {
  SingleChoice = 'SingleChoice',
  MultipleChoice = 'MultipleChoice',
  RangeSelection = 'RangeSelection',
  FreeText = 'FreeText',
  Ranking = 'Ranking',
  Date = 'Date',
}
